import React from 'react';
import { Table, Glyphicon } from 'react-bootstrap';
import { DocumentUpload } from "areas/shared/controls";
import { Scrollbars } from 'react-custom-scrollbars';
import { DownloadFileLink } from 'fw/components';
import * as Formatting from 'fw/misc/Formatting';
import * as Modals from 'fw/globals/Modals';
import Moment from 'moment';
import * as App from 'modules/app/App';

class FileGrid extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            documents: this.props.documents
        }
    }

    renderRow = (file, i) => {
        const row = (
            <tr key={i}>
                <td className="react-grid-Cell">
                    <DownloadFileLink 
                        storageToken={file.storageToken} 
                        fileName={file.fileName} 
                        title={file.fileName} 
                        useEncryption={this.props.useEncryption}
                        buttonName={file.fileName} 
                        wrapFileNameLength={this.props.wrapFileNameLength}
                        buttonStyle="link" />
                </td>
                <td className="col-md-3 react-grid-Cell">
                    {file.addedBy}
                </td>
                <td className="col-md-3 react-grid-Cell" style={{ textAlign: "center" }}>
                    {Formatting.formatClientDateTime(file.addedDate)}
                </td>
                {!this.props.readonly &&
                    <td
                        className="react-grid-Cell"
                        align="center"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleDelete(file)}><Glyphicon glyph="remove" /></td>
                }
            </tr>
        );
        return [row]
    }

    handleAdd = (document) => {

        if (!document || document.fileName == null)
            return;

        document.addedBy = App.context().userName;
        document.addedDate = Moment.utc();
        document.entityId = -(Date.now() | 0);

        var documents = this.state.documents;

        documents.unshift(document);

        this.setState({ documents: documents },
            () => { this._documentUpload.blankFile(0); });

        this.props.onAdd && this.props.onAdd(document);
    }

    findIndex = (key) => {
        return this.state.documents.findIndex(function (element) {
            return element.entityId === key;
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.documents !== this.props.documents)
        {
            this.setState({
                documents: nextProps.documents
            });
        }
    }

    handleDelete = (document) => {
        if (!document)
            return;

        Modals.remove({
            title: "Removing document",
            elementType: "document",
            name: document.fileName,
            onYes: () => {
                var index = this.findIndex(document.entityId);
                var documents = this.state.documents;
                documents.splice(index, 1);
                this.setState({ documents: documents });
                this.props.onDelete && this.props.onDelete(document);
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                <Scrollbars style={{ height: 150, border: "solid hsl(0,0%,80%) 1px" }} autoHide >
                    <Table responsive>
                        <thead>
                            <tr>
                                <th className="react-grid-HeaderCell">Document Name</th>
                                <th className="react-grid-HeaderCell" style={{ width: "180px" }}>Added By</th>
                                <th className="react-grid-HeaderCell" style={{ width: "170px" }}>Date/Time</th>
                                <th className="react-grid-HeaderCell" style={{ width: "40px" }} />
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.documents.map((file, i) => {
                                return this.renderRow(file, i);
                            })}
                        </tbody>
                    </Table>
                </Scrollbars>
                {!this.props.readonly &&
                    <div style={{ width: "100%" }}>
                        <DocumentUpload
                            ref={(c) => this._documentUpload = c}
                            onChange={file => this.handleAdd(file)}
                            skipConfirmation={true}
                            wrapFileNameLength={this.props.wrapFileNameLength}
                            useEncryption={this.props.useEncryption}
                            folder={this.props.folder}
                        />
                    </div>
                }
            </React.Fragment>
        )
    }
}

export default FileGrid;

FileGrid.defaultProps = {
    useEncryption: false,
    wrapFileNameLength: 120
};


// WEBPACK FOOTER //
// ./src/areas/shared/components/fileGrid/FileGrid.js